import React from 'react';
import MainFooter from './MainFooter';
import MainNav from './MainNav';
import "./layout.css";

const Layout = (props) => {
  const { children, appInfo, className } = props;

  return (
    <div className={`dashboard-main-page${className ? ` ${className}` : ""}`}>
      <MainNav appInfo={appInfo} />
      {children}
      <MainFooter />
    </div>
  );
};

export default Layout;
